import React from 'react';
import env from '../../env';

/**
 * OrganizationSchema Component
 * 
 * Implements Schema.org Organization structured data for SEO.
 * Follows best practices as defined by Schema.org:
 * - https://schema.org/Organization
 * 
 * This schema should be used on the homepage only to provide
 * organization information to search engines.
 * 
 * @example
 * {isHomepage && <OrganizationSchema />}
 */
export function OrganizationSchema() {
  // Use useEffect to inject organization schema directly into DOM
  React.useEffect(() => {
    // Remove any existing organization schema script
    const existingScript = document.querySelector('script[data-organization-schema]');
    if (existingScript) {
      existingScript.remove();
    }

    // Create new JSON-LD script for organization
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-organization-schema', 'true');
    
    const organizationSchema = {
      "@context": "https://schema.org/",
      "@type": "Organization",
      "name": env.siteName,
      "url": env.baseOrigin,
      "logo": env.baseOrigin + "/logo192.png",
      "description": "Scunci - Premium hair accessories and styling tools for all hair types. Shop our collection of ponytail holders, hair ties, headbands, and professional styling products.",
      "foundingDate": "1962",
      "areaServed": "Australia",
      "brand": {
        "@type": "Brand",
        "name": env.siteName
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": "English",
        "areaServed": "Australia"
      },
      "sameAs": [
        "https://www.facebook.com/ScunciAustralia",
        "https://www.instagram.com/scunci_au"
      ]
    };

    script.textContent = JSON.stringify(organizationSchema);
    document.head.appendChild(script);

    // Cleanup function to remove schema when component unmounts
    return () => {
      const scriptToRemove = document.querySelector('script[data-organization-schema]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []); // Empty dependency array means this runs once on mount

  // Return null since we're using direct DOM manipulation
  return null;
}

